import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class StorageService {
  set(key: string, data: unknown) {
    if (key) {
      localStorage.setItem(key, JSON.stringify(data));
    }
  }

  exists(key: string): boolean {
    if (key) {
      const data: string | null = localStorage.getItem(key);
      return data && data !== "undefined" && data !== "null" ? true : false;
    }
    return false;
  }

  get<T>(key: string) {
    if (key) {
      if (this.exists(key)) {
        const data: string | null = localStorage.getItem(key);
        return JSON.parse(data as string) as T;
      }
    }
    return null;
  }

  remove(key: string) {
    if (key) {
      localStorage.removeItem(key);
    }
  }

  clear() {
    localStorage.clear();
  }
}
